import { type TFunction } from "i18next";
import { notifications } from "@mantine/notifications";

export const failureDuringApproval = (
  t: TFunction,
): void => {
  notifications.show({
    message: t('during_approval'),
    title: t('something_went_wrong'),
    color: 'red',
  });
};
